export default "__VITE_ASSET__yPKRyPoJ__"